export default "__VITE_ASSET__CK_Ucx3n__"